<template>
  <header class="site-header">
    <nav>
      <a href="#home" class="nav-logo" @click.prevent="handleNavClick(SECTION_HREF.home)">
        <Logo />
      </a>
      <ul class="nav-links">
        <li>
          <a
            href="#home"
            :class="{ active: isActive(SECTION_HREF.home) }"
            @click.prevent="handleNavClick(SECTION_HREF.home)"
          >{{ m.nav.home }}</a>
        </li>
        <li>
          <a
            href="#about"
            :class="{ active: isActive(SECTION_HREF.about) }"
            @click.prevent="handleNavClick(SECTION_HREF.about)"
          >{{ m.nav.about }}</a>
        </li>
        <li>
          <a
            href="#services"
            :class="{ active: isActive(SECTION_HREF.services) }"
            @click.prevent="handleNavClick(SECTION_HREF.services)"
          >{{ m.nav.services }}</a>
        </li>
        <li>
          <a
            href="#references"
            :class="{ active: isActive(SECTION_HREF.references) }"
            @click.prevent="handleNavClick(SECTION_HREF.references)"
          >{{ m.nav.references }}</a>
        </li>
      </ul>
      <div class="nav-actions">
        <AccessibilityToggle />
        <LangSwitch :aria-label="m.nav.languageSelection" />
        <a
          href="#contact"
          class="nav-cta"
          :class="{ active: isActive(SECTION_HREF.contact) }"
          @click.prevent="handleNavClick(SECTION_HREF.contact)"
        >{{ m.nav.contact }}</a>
      </div>
      <button
        class="nav-toggle"
        type="button"
        :aria-expanded="mobileMenuOpen"
        aria-controls="mobile-menu"
        @click="toggleMobileMenu"
        :aria-label="m.nav.menu"
      >☰</button>
    </nav>
    <div id="mobile-menu" class="mobile-menu" :class="{ open: mobileMenuOpen }">
      <a
        href="#home"
        :class="{ active: isActive(SECTION_HREF.home) }"
        @click.prevent="handleNavClick(SECTION_HREF.home)"
      >{{ m.nav.home }}</a>
      <a
        href="#about"
        :class="{ active: isActive(SECTION_HREF.about) }"
        @click.prevent="handleNavClick(SECTION_HREF.about)"
      >{{ m.nav.about }}</a>
      <a
        href="#services"
        :class="{ active: isActive(SECTION_HREF.services) }"
        @click.prevent="handleNavClick(SECTION_HREF.services)"
      >{{ m.nav.services }}</a>
      <a
        href="#references"
        :class="{ active: isActive(SECTION_HREF.references) }"
        @click.prevent="handleNavClick(SECTION_HREF.references)"
      >{{ m.nav.references }}</a>
      <a
        href="#contact"
        :class="{ active: isActive(SECTION_HREF.contact) }"
        @click.prevent="handleNavClick(SECTION_HREF.contact)"
      >{{ m.nav.contact }}</a>
      <AccessibilityToggle mobile />
      <LangSwitch mobile :aria-label="m.nav.languageSelection" />
    </div>
  </header>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { SECTION_HREF } from '~/constants/sections'

const { messages: m } = useI18n()
const { activeSection, setActiveSection } = useActiveSection()
const { scrollToTop, scrollToSection } = useSmoothScroll()
const mobileMenuOpen = ref(false)

const isActive = (href: string) => activeSection.value === href

const handleNavClick = (href: string) => {
  setActiveSection(href)

  if (href === SECTION_HREF.home) {
    scrollToTop()
  } else {
    scrollToSection(href)
  }

  mobileMenuOpen.value = false
}

const toggleMobileMenu = () => {
  mobileMenuOpen.value = !mobileMenuOpen.value
}
</script>